<template>
  <component :is="hTag" v-bind="$attrs" :class="classes">
    <span v-if="variant">
      <slot></slot>
    </span>
    <slot v-else></slot>
  </component>
</template>
<script>
export default {
  name: "M4Heading",
  props: {
    level: {
      type: String,
      required: true
    },
    tag: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    classes() {
      let classes = ["heading"];
      classes.push("heading--" + this.level);
      if (this.variant) {
        classes.push("heading--variant-" + this.variant);
      }
      return classes;
    },
    hTag() {
      return "h" + this.level;
    }
  }
};
</script>
